/**
 * Hero-Background für die Aktions-Landing.
 *
 * Nutzt ein echtes Foto (`/media/aktion/hero-house.jpg`) — modernes
 * Einfamilienhaus mit Satteldach, blauer Himmel, grüne Blätter in den
 * Ecken. Kein CSS-Gradient und keine SVG-Wolken mehr; das Foto liefert
 * die komplette Kulisse.
 *
 * Ein dezenter Top-Overlay (0 → 15% Schwarz) verbessert die Lesbarkeit
 * der schwarzen Headline auf dem Himmel-Anteil des Bildes.
 */

export default function AktionSky() {
    return (
        <div
            aria-hidden
            className="absolute inset-0 overflow-hidden"
            style={{ zIndex: 0 }}
            data-testid="aktion-sky"
        >
            <img
                src="/media/aktion/hero-house.jpg"
                alt=""
                className="absolute inset-0 w-full h-full"
                style={{
                    objectFit: "cover",
                    objectPosition: "center bottom",
                }}
                loading="eager"
                decoding="async"
            />
            {/* Sanfter Top-Overlay für Text-Kontrast (nur oberer Bereich). */}
            <div
                className="absolute inset-x-0 top-0"
                style={{
                    height: "45%",
                    background: "linear-gradient(180deg, rgba(0,0,0,0.18) 0%, rgba(0,0,0,0) 100%)",
                    pointerEvents: "none",
                }}
            />
        </div>
    );
}
